import { Link } from "react-router-dom";
import { categories, news } from "@/mocks/content";

export default function CategoryBoards() {
  const countOf = (slug: string) =>
    news.filter((n) => n.category === slug).length;
  return (
    <section className="mx-auto max-w-7xl px-4 pb-10 md:px-6">
      <div className="mb-5 flex items-end justify-between">
        <div>
          <p className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-600">
            <span className="inline-block h-3 w-1 rounded-full bg-primary-500" />
            Discover Columns
          </p>
          <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-900 md:text-3xl">
            六大栏目，总有一颗瓜为你留着
          </h2>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((c) => (
          <Link
            key={c.slug}
            to={`/category/${c.slug}`}
            className="group flex items-start gap-4 rounded-xl border border-background-200 bg-background-50 p-5 transition-all hover:-translate-y-0.5 hover:border-primary-300"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-2xl text-primary-700 transition-colors group-hover:bg-primary-600 group-hover:text-background-50">
              <i className={c.icon} />
            </span>
            <span className="min-w-0">
              <span className="flex items-center gap-2">
                <span className="font-heading text-base font-bold text-foreground-900">
                  {c.name}
                </span>
                <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-700">
                  {countOf(c.slug)} 篇
                </span>
              </span>
              <span className="mt-1 block text-xs font-medium text-primary-600">
                {c.tagline}
              </span>
              <span className="mt-2 line-clamp-2 block text-sm leading-relaxed text-foreground-600">
                {c.intro}
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}